import { AfterViewInit, Directive, Input, OnDestroy, Optional, Self } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { RouteHistoryMode } from '../route-history-mode';
import { RouteHistoryService } from '../route-history.service';
import { IHaveRouterOutlet } from './IHaveRouterOutlet';

@Directive({
  selector: '[plrHistoryOutlet]'
})
export class HistoryOutletDirective implements AfterViewInit, OnDestroy {

  @Input()
  historyMode: RouteHistoryMode;

  constructor(private _routeHistory: RouteHistoryService,
    @Self() @Optional() private _routerOutlet: RouterOutlet,
    @Self() @Optional() private _routerContainer: IHaveRouterOutlet) {
  }

  ngAfterViewInit() {
    if (!this._routerOutlet && this._routerContainer) {
      this._routerOutlet = this._routerContainer.routerOutlet;
    }
    if (this._routerOutlet) {
      if (this.historyMode) {
        this._routeHistory.registerRouterOutlet(this._routerOutlet, { mode: this.historyMode });
      } else {
        this._routeHistory.registerRouterOutlet(this._routerOutlet);
      }
    }
  }

  ngOnDestroy() {
    this._routeHistory.unRegisterRouterOutlet(this._routerOutlet);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/layout/history-outlet/history-outlet.directive.ts